import styled from 'styled-components';

export const PageTitle = styled.h1`
  margin: 3rem 0;
`;
